import i18n, { t } from 'i18next';
import moment from 'moment';

import { Language } from '../../../locale/constants';

export function getDownloadDateInfo(action, downloadDate) {
    const date = moment.utc(downloadDate);
    const currentDate = moment.utc();

    let diffMinutes = Math.round((currentDate - date) / (1000 * 60));
    let diffHours = Math.round(diffMinutes / 60);
    let diffDays = Math.round(diffHours / 24);

    if (diffDays > 1) {
        return t('flightTaskPage.action.daysAgo', { action, diffDays });
    } else if (diffDays === 1) {
        return t('flightTaskPage.action.dayAgo', { action });
    } else if (diffHours > 1) {
        return t('flightTaskPage.action.hoursAgo', { action, diffHours });
    } else if (diffHours === 1) {
        return t('flightTaskPage.action.hourAgo', { action });
    } else if (diffMinutes > 1) {
        return t('flightTaskPage.action.minutesAgo', { action, diffMinutes });
    } else if (diffMinutes === 1) {
        return t('flightTaskPage.action.minuteAgo', { action });
    } else {
        return t('flightTaskPage.action.justNow', { action: i18n.language === Language.en ? action.toLowerCase() : action });
    }
}
